import React, { useState } from 'react';
import { Link } from 'react-scroll';
import logo from '../../Assets/img/logo.png'

const Navbar = () => {
    let [open,setOpen]=useState(false);
    return (
        <div className='n-wrapper flex justify-around mt-14'>
        <div className="n-left">
            <div className="n-logo flex cursor-pointer">
                 <img src={logo} alt="" />
            </div>
        </div>
        <div className="flex">
            <div className="n-list ">
            <div onClick={()=>setOpen(!open)} className='text-3xl absolute right-8 top-16 cursor-pointer md:hidden'>
      <ion-icon name={open ? 'close':'menu'}></ion-icon>
      </div>
                <ul className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-primary lg:bg-white font-bold md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${open ? 'top-0 ':'top-[-490px]'}`}>
                <Link  to="" spy={true} smooth={true} offset={50} duration={500} > <li className='text-xl mt-3 cursor-pointer hover:text-primary duration-700 text-center lg:text-black text-white lg:pl-16'>Home</li></Link>
                    <Link  to="about" spy={true} smooth={true} offset={50} duration={500} > <li className='text-xl mt-3 cursor-pointer hover:text-primary duration-700 text-center lg:text-black text-white lg:pl-16'>About</li></Link>
                    <Link  to="about" spy={true} smooth={true} offset={50} duration={500} > <li className='text-xl mt-3 cursor-pointer hover:text-primary duration-700 text-center lg:text-black text-white lg:pl-16'>Skill</li></Link>
                    <Link  to="work" spy={true} smooth={true} offset={50} duration={500} >   <li className='text-xl mt-3 cursor-pointer hover:text-primary duration-700 text-center lg:text-black text-white lg:pl-16'>Works</li></Link>
                    <Link  to="contact" spy={true} smooth={true} offset={50} duration={500} > <li className='text-xl mt-3 cursor-pointer hover:text-primary duration-700 text-center lg:text-black text-white lg:pl-16'>Contact</li></Link>
                   
                   
                 
                   
                </ul>
            </div>
           <Link to="contact" spy={true} smooth={true} offset={50} duration={500}> <button className="btn btn-outline btn-primary font-bold rounded-full hidden lg:block  px-10 pt-1 lg:ml-9">Hire Me</button></Link>
        </div>
        
    </div>


    );
};

export default Navbar;
